const COVID19 = 'COVID-19'
const MEDICAL = 'Medical issue'
const HOME = 'Home/property issue'
const CAR = 'Car issue'

const EVENT_ONLY = 'EVENT_ONLY'
const EXPENSE_ONLY = 'EXPENSE_ONLY'
const EVENT_AND_EXPENSE = 'EVENT_AND_EXPENSE'
const NONE = 'NONE'

const EVENT_DOCUMENTATION_REQUIRED = [EVENT_ONLY, EVENT_AND_EXPENSE]
const EXPENSE_DOCUMENTATION_REQUIRED = [EXPENSE_ONLY, EVENT_AND_EXPENSE]

export default {
  COVID19,
  MEDICAL,
  HOME,
  CAR,
  EVENT_ONLY,
  EXPENSE_ONLY,
  EVENT_AND_EXPENSE,
  NONE,
  EVENT_DOCUMENTATION_REQUIRED,
  EXPENSE_DOCUMENTATION_REQUIRED,
}
